<script context="module">
	import * as easing from 'svelte/easing';
	import * as transitions from './transitions';
	import TransitionForm from './TransitionForm.svelte';
	import LoremIpsum, { typeValues } from './LoremIpsum.svelte';
	import Button from './Button.svelte';
	import { writable } from 'svelte/store';
	import { outTransitionValues, inTransitionValues, controls } from './stores';
	import CodeSnippet from './CodeSnippet.svelte';
	import Select from './Select.svelte';
	import { renderCodeSnippet } from './renderSnippet';

	const transitionOptions = Object.keys(transitions);
	const easingOptions = Object.keys(easing);
</script>
<script>
	const handleShowButtonClick = () => {
		$controls.on = !$controls.on;
	};
	
	$: showButtonLabelMessage = $controls.on ? 'show out' : 'show in';
	
	$:  inTransition = transitions[$inTransitionValues.transitionName];
	$:  outTransition = transitions[$outTransitionValues.transitionName];
	
	$: intransitionOptions = { 
		duration: $inTransitionValues.transitionDuration, 
		easing: easing[$inTransitionValues.easingName] 
	};
	$: outTransitionOptions = { 
		duration: $outTransitionValues.transitionDuration, 
		easing: easing[$outTransitionValues.easingName] 
	};

	$: codeSnippet = renderCodeSnippet($inTransitionValues, $outTransitionValues);
</script>
 
<style> 	
	main {
		--content-width: 880px; 
		--header-height: 50px;
		--header-z-index: 20;
		width: 100%;
		overflow: hidden;
		display: flex;
		flex-flow: column nowrap;
		justify-content: flex-start;
		align-items: center;
	}

	article {
		display: flex;
		overflow: hidden;
		flex-flow: column nowrap;
		align-items: center;
		max-width: var(--content-width);
		max-width: min(var(--content-width), 100%);
		gap: 8px;
		padding: var(--header-height) 0 12px;
		box-sizing: border-box;
	}
	
	main, main *, main *::after, main *::before {
		box-sizing: border-box;
	}

	.transition {
		display: inline-block;
	}

	.section {
		width: min(var(--content-width), 100%);
		display: flex;
		overflow: hidden;
		flex-flow: column nowrap;
		justify-content: flex-start;
		border-radius: 8px;
		margin: 0;
		padding: 0.4rem 0.4rem 0;
		border: 1px solid black;
	}
	
	.output {
		height: 420px;
	}
	
	h1 {
		font-size: 1.2rem;
		line-height: 1.2;
	}
	
	h2 {
		font-size: 1.2rem;
		margin: 0.2rem 0;
		font-size: 1.2rem;
		line-height: 1.2;
	}
	
		h3 {
		font-size: 1.2rem;
		text-align: center;
		margin: 0;
		padding: 0;
		line-height: 1.8;
	}	
	
	.formWrapper {
		display: grid;
		grid-template-columns: 1fr;
		grid-column-gap: 1rem;
		grid-row-gap: 0.5rem;
		overflow: hidden;
		padding: 0.2rem;
		width: 100%;
	}
	
	@media (min-width: 600px) {
	 .formWrapper {
		 grid-template-columns: repeat(2, 1fr);
		}
	}
	
	.controlsWrapper {
		display: flex;
		width: 100%;
	  justify-content: space-evenly;
		align-items: center;
		padding: 0.2rem;
	}
	
	article header {
		position: fixed;
		top: 0;
		background: #fff;
		display: flex;
		justify-content: space-between;
		align-items: center;
		left: 0;
		width: 100%;
		height: var(--header-height);
		overflow: hidden;
		background-color: #fff;
		padding: 0 16px;
		box-shadow: 0 0 1px 2px rgb(0, 0, 0, 0.3);
		z-index: var(--header-z-index);
	}
	
</style>

<main>
  <article>
		<header><h1>Clip path Transitions</h1><Button on:click={handleShowButtonClick}>{showButtonLabelMessage}</Button></header>
  <div class=formWrapper>
    <TransitionForm values={inTransitionValues} easingOptions={easingOptions} transitionOptions={transitionOptions}>
  	  <h3 slot="heading">In transition</h3>
    </TransitionForm>
    <TransitionForm values={outTransitionValues} easingOptions={easingOptions} transitionOptions={transitionOptions}>
  	  <h3 slot="heading">Out transition</h3>
    </TransitionForm>
  </div>
	<form class=controlsWrapper>
  <Button on:click={handleShowButtonClick}>{showButtonLabelMessage}</Button>
	<!-- svelte-ignore a11y-label-has-associated-control -->
	<label for="lorem-type">
		 animating content
  	<Select id="lorem-type" bind:value={$controls.loremIpsumType}>
  	  {#each typeValues as type} 
  		<option value={type}>{type}</option>
  		{/each}
	  </Select>
	</label>
	</form>
	<section class="section">
		<h2>
			Code
		</h2>
		<CodeSnippet>{codeSnippet}</CodeSnippet>
	</section>
  <section class="section output">
		<h2>
			Output
		</h2>
    {#if $controls.on}
	   <div 
	  	 class=transition
	     in:inTransition={intransitionOptions}
		   out:outTransition={outTransitionOptions}>
 	   <LoremIpsum type={$controls.loremIpsumType} />
	  </div>
    {/if}
	</section>
  </article>
	<footer><ul>
		<li>Inspired by <a href="https://css-tricks.com/animating-with-clip-path">{"css-tricks.com/animating-with-clip-path"}</a>
		</li>
		<li>docs <a href="https://svelte.dev/docs#template-syntax-element-directives-in-fn-out-fn">https://svelte.dev/docs</a></li></ul></footer>
</main>